import React from 'react';
import { DEVICE_FILTERS, getUserPlatform, PLATFORMS } from '../../utils/device';
import classes from './deviceFilter.module.css';

const OPTIONS = [
  { value: DEVICE_FILTERS.ALL, label: 'All', icons: [] },
  { value: DEVICE_FILTERS.ANDROID, label: 'Android', icons: ['/androidicon.svg'] },
  { value: DEVICE_FILTERS.IOS, label: 'iOS', icons: ['/iphoneicon.png'] },
  { value: DEVICE_FILTERS.DESKTOP, label: 'Desktop', icons: ['/windows.png', '/macos.png'] },
];

// Desktop-only single-select device filter. Returns null on mobile UA so
// mobile web keeps its automatic platform lock.
export default function DeviceFilter({ value, onChange }) {
  if (getUserPlatform() !== PLATFORMS.DESKTOP) return null;

  return (
    <div className={classes.container} role="radiogroup" aria-label="Filter by device">
      {OPTIONS.map((opt) => {
        const selected = value === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            role="radio"
            aria-checked={selected}
            className={`${classes.pill} ${selected ? classes.selected : ''}`}
            onClick={() => onChange(opt.value)}
          >
            {opt.icons.map((src) => (
              <img key={src} src={src} alt="" width={18} height={18} className={classes.icon} />
            ))}
            <span>{opt.label}</span>
          </button>
        );
      })}
    </div>
  );
}
